import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ExpandedCardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}

export const ExpandedCardDialog = ({
  open,
  onOpenChange,
  title,
  children,
}: ExpandedCardDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[70vh] bg-card border-border/60 flex flex-col p-0 gap-0">
        <DialogHeader className="p-4 border-b border-border/60 flex flex-row items-center justify-between space-y-0 shrink-0">
          <DialogTitle className="z-h2 text-foreground">{title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto p-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
};
